import React from 'react';
import { FaSpinner } from 'react-icons/fa';
import TitleUpdateCard from './TitleUpdateCard';
import { PROJECT_TYPE_LABELS } from '../hooks/useProjectTypeFilter';
import styles from '../ManagePage.module.css';

// Saved Update Title runs for the Manage page's "Title" filter view. Data comes
// from useTitleUpdateHistory in ManagePage so the merged default grid and this
// view share one fetch. onOpen opens the selected run inline (results view).
const TitleUpdateSection = ({ data, onOpen }) => {
  const { loading, error, projects } = data;
  const hasProjects = projects.length > 0;

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <div className={styles.sectionHeaderTitle}>
          <span className={styles.allProjectsTitle}>{PROJECT_TYPE_LABELS.update_title} ({projects.length})</span>
        </div>
      </div>
      {loading && (
        <div className={styles.loading}><FaSpinner className={styles.spinner} /></div>
      )}
      {error && !loading && (
        <div className={styles.error}>{error}</div>
      )}
      {!loading && !error && !hasProjects && (
        <div className={styles.emptyState}>
          <h3>No title updates</h3>
          <p>Run Update Title from the navbar to generate new titles — each run shows up here.</p>
        </div>
      )}
      {!loading && !error && hasProjects && (
        <div className={styles.smallCardsGrid}>
          {projects.map((project) => (
            <TitleUpdateCard key={project._id} project={project} onOpen={onOpen} />
          ))}
        </div>
      )}
    </div>
  );
};

export default TitleUpdateSection;
